import { render, staticRenderFns } from "./WdcCampaignCustomerRecord.vue?vue&type=template&id=032aff62"
import script from "./WdcCampaignCustomerRecord.vue?vue&type=script&lang=js"
export * from "./WdcCampaignCustomerRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports